// Bulk Order Form engine (Josh 10/17): "take what currently is my paid for jotform. and recreate my own version on the
// new site - so clients who currently drag and drop 30+ designs can still do that ... it will live price and show their
// total as they go. at the end they just check out and it submits the order."
//
// This file owns the parts that must equal the rest of the shop exactly:
//   - the option lists (the builder's own material ids, laminate ids and products),
//   - a row's price (the same /api/quote call and cent rounding the builder uses; the checkout Worker re-prices
//     every line the same way and refuses any difference),
//   - the art measuring: a port of Command's app/measure.py content box + the size-price skill's size rules
//     ("this form needs to be hooked into my skill that automatically checks the sizing of each png. so when they
//     select 6 tall and upload a 5x5 it re-corrects the size to 6x6", Josh 10/17),
//   - the rush fee (size-price skill, Josh 10/11: "15% or 50$ minimum is the rush order fee"),
//   - the hand-off: rows become ordinary builder cart items in the shared cart, then the configurator's cart drawer
//     runs the normal checkout (the same path the jar pages use).
// bulk-order.js owns everything on screen and calls window.VPBulkCart.
(function () {
  'use strict';
  if (window.VPBulkCart) return;

  var MIN_QTY = 10;                      // the Jotform's own minimum ("Quantity (Minimum 10)")
  var SPECIALTY_MIN_QTY = 20;            // Josh 10/17: "make the minimum for any specialty option other than regular vinyl
                                         // gloss or matte 20" (the Jotform's specialty table said "minimum 20")
  var MAX_ROWS = 90;                     // checkout Worker LIMITS.items
  var ORDER_KEY = 'vp_cart_order';       // order-level extras (rush, mockups, Instagram...) read by the checkout
  var FORM = 'bulk-order';

  // Jotform "Vinyl" column order; ids are the builder's MATERIALS ids, finish3d = VPQuote3D base vinyl.
  var MATERIALS = [
    { id: 'white-vinyl', label: 'White Vinyl', finish3d: 'gloss', white: false },
    { id: 'holo',        label: 'Holo',        finish3d: 'holo', white: true },
    { id: 'reflective',  label: 'Reflective',  finish3d: 'reflective', white: true },
    { id: 'gold',        label: 'Gold',        finish3d: 'gold', white: true },
    { id: 'glitter',     label: 'Glitter',     finish3d: 'glitter', white: true },
    { id: 'chrome',      label: 'Chrome',      finish3d: 'chrome', white: true }
  ];

  // The builder's laminate chips (configurator.html #finishToggle), same ids, labels and groups.
  // finish/specialty = the builder globals currentFinish/currentSpecialty; lam3d = VPQuote3D laminate;
  // quote = the /api/quote finish key when the material is White Vinyl (the builder's vpQuoteFinish()).
  var LAMINATES = [
    { id: 'gloss',  label: 'Gloss',  group: 'Standard', finish: 'glossy', specialty: 'none',  lam3d: 'gloss',  quote: 'gloss' },
    { id: 'matte',  label: 'Matte',  group: 'Standard', finish: 'matte',  specialty: 'none',  lam3d: 'matte',  quote: 'matte' },
    { id: 'satin',  label: 'Satin',  group: 'Standard', finish: 'glossy', specialty: 'satin', lam3d: 'satin',  quote: 'gloss' },
    // cuts: Stardust is die cut only (Josh 10/18), same as the builder's data-cut="die" chip.
    { id: 'glitter-lam-stardust', label: 'Stardust', group: 'Standard', finish: 'glossy', specialty: 'glitter-lam-stardust', lam3d: 'glitter-stardust', quote: 'stardust', cuts: ['die'] },
    { id: 'glitter-lam-silver',   label: 'Apollo Silver', group: 'Galactic Series', finish: 'glossy', specialty: 'glitter-lam-silver',   lam3d: 'glitter-silver',   quote: 'silver-glitter' },
    { id: 'glitter-lam-gold',     label: 'Orion Gold',    group: 'Galactic Series', finish: 'glossy', specialty: 'glitter-lam-gold',     lam3d: 'glitter-gold',     quote: 'gold-glitter' },
    { id: 'glitter-lam-rainbow',  label: 'Cosmic Shift',  group: 'Galactic Series', finish: 'glossy', specialty: 'glitter-lam-rainbow',  lam3d: 'glitter-rainbow',  quote: 'rainbow-glitter' },
    { id: 'holo-lam-hearts',      label: 'Hearts',        group: 'Galactic Series', finish: 'glossy', specialty: 'holo-lam-hearts',      lam3d: 'holo-hearts',      quote: 'heart-holo' },
    { id: 'holo-lam-fracture',    label: 'Fracture',      group: 'Spectrum', finish: 'glossy', specialty: 'holo-lam-fracture',  lam3d: 'holo-fracture',  quote: 'fracture' },
    { id: 'holo-lam-prismatic',   label: 'Prismatic',     group: 'Spectrum', finish: 'glossy', specialty: 'holo-lam-prismatic', lam3d: 'holo-prismatic', quote: 'prismatic' },
    { id: 'holo-lam-cosmic',      label: 'Super Cosmic',  group: 'Spectrum', finish: 'glossy', specialty: 'holo-lam-cosmic',    lam3d: 'holo-cosmic',    quote: 'super-cosmic' },
    { id: 'holo-lam-hex',         label: 'Hex',           group: 'Spectrum', finish: 'glossy', specialty: 'holo-lam-hex',       lam3d: 'holo-hex',       quote: 'hex' }
  ];

  // "cut style (die cut, kisscut)". Builder products (product-state.js SWITCHER_GROUPS custom-stickers).
  // Josh 10/17: "it should be kisscut with transfer tape! and that should be the default option on this form" — the
  // weeded kiss cut the Jotform orders always were: the site's Kiss Cut + Transfer product, priced on the tape chart.
  // (The id stays 'kiss' so rows saved on this device keep their cut.)
  var CUTS = [
    { id: 'kiss', label: 'Kiss cut + transfer tape', short: 'Kiss cut', chipId: 'transfer', productName: 'Kiss Cut Transfer Stickers', quote: 'tape', cut3d: 'tape',
      thumb: (window.VP_CDN+"customstickers_transferstickers.png?v=905c8b97f6") },
    { id: 'die',  label: 'Die cut',  chipId: 'die-cut',  productName: 'Die Cut Stickers', quote: 'die', cut3d: 'die',
      thumb: (window.VP_CDN+"customstickers_diecutstickers.png?v=04c59469b7") }
  ];

  var WHITE_INK = [
    { id: 'none', label: 'No white' },
    { id: 'spot', label: 'Spot white' },
    { id: 'full', label: 'Full white' }
  ];

  var FIN_LAB = { gloss: 'Gloss', matte: 'Matte', glitter: 'Glitter', holo: 'Holo', reflective: 'Reflective', chrome: 'Chrome', gold: 'Gold' };

  function byId(list, id) { for (var i = 0; i < list.length; i++) if (list[i].id === id) return list[i]; return null; }

  // ── money ────────────────────────────────────────────────────────────────────
  function cents(n) { return Math.round(Number(n) * 100); }
  function money(c) { return (c / 100).toFixed(2); }

  // ── sizes (size-price skill: "Round to two decimals, drop trailing zeros") ──
  function round2(x) { return Math.round(Number(x) * 100 + 1e-9) / 100; }
  function round3(x) { return Math.round(Number(x) * 1000 + 1e-9) / 1000; }   // measure.py _r()
  function inch(x) { return String(round2(x)); }

  // fitSize({ side: 'h'|'w'|'long', value }, aspect) -> { h, w } in inches, 2 decimals.
  // Skill: "One side named ... keep that side; the other side comes from the artwork's shape
  // (artwork_aspect_w_over_h). A single unlabeled number is the longest side unless they said height or width."
  // aspect = width / height of the trimmed art (3 decimals, as vp measure reports it). No aspect -> null.
  function fitSize(anchor, aspect) {
    var v = Number(anchor && anchor.value);
    var a = Number(aspect);
    if (!(v > 0) || !(a > 0) || !isFinite(a)) return null;
    var side = anchor.side === 'w' ? 'w' : anchor.side === 'long' ? (a >= 1 ? 'w' : 'h') : 'h';
    if (side === 'h') return { h: round2(v), w: round2(v * a) };
    return { w: round2(v), h: round2(v / a) };
  }

  // ── art measuring: app/measure.py + measure_cut._content_box, in the browser ─
  // Content box: alpha > 16 when the file has an alpha channel; otherwise trim near-white (r,g,b > 245) only when all
  // four corners are near-white; otherwise the whole image. "Has alpha" follows Pillow's mode: PNG colour type 4/6, or
  // palette + tRNS; WebP with an alpha flag. JPEG never.
  var MAX_MEASURE_PX = 24e6;   // bigger images are measured scaled down (aspect error < 0.1%)

  function readHead(file, n) {
    return file.slice(0, n).arrayBuffer().then(function (buf) { return new Uint8Array(buf); });
  }

  function pngHasAlpha(b) {
    if (b.length < 33 || b[0] !== 0x89 || b[1] !== 0x50) return null;
    var type = b[25];
    if (type === 4 || type === 6) return true;
    if (type !== 3) return false;
    // palette: alpha only with a tRNS chunk (before IDAT)
    var i = 8;
    while (i + 8 <= b.length) {
      var len = (b[i] << 24 | b[i + 1] << 16 | b[i + 2] << 8 | b[i + 3]) >>> 0;
      var name = String.fromCharCode(b[i + 4], b[i + 5], b[i + 6], b[i + 7]);
      if (name === 'tRNS') return true;
      if (name === 'IDAT' || name === 'IEND') return false;
      i += 12 + len;
    }
    return false;
  }

  function pngDpi(b) {
    var i = 8;
    while (i + 8 <= b.length) {
      var len = (b[i] << 24 | b[i + 1] << 16 | b[i + 2] << 8 | b[i + 3]) >>> 0;
      var name = String.fromCharCode(b[i + 4], b[i + 5], b[i + 6], b[i + 7]);
      if (name === 'pHYs' && i + 17 <= b.length) {
        var x = (b[i + 8] << 24 | b[i + 9] << 16 | b[i + 10] << 8 | b[i + 11]) >>> 0;
        var y = (b[i + 12] << 24 | b[i + 13] << 16 | b[i + 14] << 8 | b[i + 15]) >>> 0;
        if (b[i + 16] === 1) return [x * 0.0254, y * 0.0254];
        return null;
      }
      if (name === 'IDAT' || name === 'IEND') return null;
      i += 12 + len;
    }
    return null;
  }

  function webpHasAlpha(b) {
    if (b.length < 30 || String.fromCharCode(b[0], b[1], b[2], b[3]) !== 'RIFF') return null;
    var chunk = String.fromCharCode(b[12], b[13], b[14], b[15]);
    if (chunk === 'VP8X') return !!(b[20] & 0x10);
    if (chunk === 'VP8L') return !!((b[24] >> 4) & 1);   // alpha_is_used bit of the VP8L header
    return false;
  }

  function kindOf(file) {
    var name = String(file && file.name || '').toLowerCase();
    var type = String(file && file.type || '').toLowerCase();
    if (type === 'application/pdf' || /\.pdf$/.test(name)) return 'pdf';
    if (type === 'image/png' || /\.png$/.test(name)) return 'png';
    if (type === 'image/jpeg' || /\.jpe?g$/.test(name)) return 'jpeg';
    if (type === 'image/webp' || /\.webp$/.test(name)) return 'webp';
    if (type === 'image/svg+xml' || /\.svg$/.test(name)) return 'svg';
    return 'file';   // Josh 10/17: any other file (AI, PSD, EPS, TIFF, ZIP…): previewed by art-files.js, sent as it is
  }
  var MIME = { pdf: 'application/pdf', png: 'image/png', jpeg: 'image/jpeg', webp: 'image/webp', svg: 'image/svg+xml' };
  var MAX_FILE_BYTES = 20 * 1024 * 1024;   // checkout Worker LIMITS.fileBytes
  var BLOCKED = /\.(exe|msi|bat|cmd|com|scr|sh|ps1|vbs|js|mjs|jar|apk|app|dmg|pkg|html?|xhtml|php)$/i;   // checkout Worker BLOCKED_EXT

  function mimeOf(file, kind) { return MIME[kind] || window.VPArtFiles.mime(file); }

  // What the shop accepts (the checkout Worker: any artwork file, 20 MB each).
  function accepts(file) {
    var kind = kindOf(file);
    if (BLOCKED.test(String(file && file.name || ''))) return { ok: false, message: 'This isn’t an artwork file. Zip it or email it to info@vinylpac.us.' };
    if (file.size > MAX_FILE_BYTES) return { ok: false, later: true, message: 'This file is over 20 MB. Add to cart now and email it to info@vinylpac.us after checkout with your order number.' };
    if (!file.size) return { ok: false, message: 'This file is empty.' };
    return { ok: true, kind: kind };
  }

  function contentBox(data, w, h, hasAlpha) {
    var x0 = w, y0 = h, x1 = -1, y1 = -1, x, y, i;
    if (hasAlpha) {
      for (y = 0; y < h; y++) {
        i = y * w * 4 + 3;
        for (x = 0; x < w; x++, i += 4) {
          if (data[i] > 16) {
            if (x < x0) x0 = x; if (x > x1) x1 = x;
            if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
      }
    } else {
      var corner = function (px, py) { var k = (py * w + px) * 4; return data[k] > 245 && data[k + 1] > 245 && data[k + 2] > 245; };
      if (!(corner(0, 0) && corner(w - 1, 0) && corner(0, h - 1) && corner(w - 1, h - 1))) return [0, 0, w, h];
      for (y = 0; y < h; y++) {
        i = y * w * 4;
        for (x = 0; x < w; x++, i += 4) {
          if (data[i] <= 245 || data[i + 1] <= 245 || data[i + 2] <= 245) {
            if (x < x0) x0 = x; if (x > x1) x1 = x;
            if (y < y0) y0 = y; if (y > y1) y1 = y;
          }
        }
      }
    }
    if (x1 < 0) return [0, 0, w, h];
    return [x0, y0, x1 + 1, y1 + 1];   // PIL getbbox(): right/bottom exclusive
  }

  function loadImage(url) {
    return new Promise(function (resolve, reject) {
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { resolve(img); };
      img.onerror = function () { reject(new Error('This image could not be opened.')); };
      img.src = url;
    });
  }

  function canvasFor(w, h) {
    var c = document.createElement('canvas');
    c.width = w; c.height = h;
    return c;
  }

  function thumbFrom(source, sw, sh, max, type) {
    var s = Math.min(1, max / sw, max / sh);
    var c = canvasFor(Math.max(1, Math.round(sw * s)), Math.max(1, Math.round(sh * s)));
    c.getContext('2d').drawImage(source, 0, 0, c.width, c.height);
    return c.toDataURL(type || 'image/png', 0.8);
  }

  function measureRaster(source, w, h, hasAlpha) {
    var s = Math.min(1, Math.sqrt(MAX_MEASURE_PX / (w * h)));
    var cw = Math.max(1, Math.round(w * s)), ch = Math.max(1, Math.round(h * s));
    var c = canvasFor(cw, ch);
    var ctx = c.getContext('2d', { willReadFrequently: true });
    ctx.drawImage(source, 0, 0, cw, ch);
    var box = contentBox(ctx.getImageData(0, 0, cw, ch).data, cw, ch, hasAlpha);
    var bw = Math.max(1, (box[2] - box[0]) / s), bh = Math.max(1, (box[3] - box[1]) / s);
    c.width = c.height = 0;
    return { px: [w, h], box: [Math.round(bw), Math.round(bh)], aspect: round3(bw / bh) };
  }

  function readDataUrl(blob) {
    return new Promise(function (resolve, reject) {
      var r = new FileReader();
      r.onload = function () { resolve(r.result); };
      r.onerror = function () { reject(new Error('The file could not be read.')); };
      r.readAsDataURL(blob);
    });
  }

  function svgAspect(text) {
    var vb = text.match(/viewBox="\s*([-\d.]+)[ ,]+([-\d.]+)[ ,]+([-\d.]+)[ ,]+([-\d.]+)/);
    if (vb && Number(vb[4]) > 0) return round3(Number(vb[3]) / Number(vb[4]));
    var wm = text.match(/\bwidth="([\d.]+)/), hm = text.match(/\bheight="([\d.]+)/);
    if (wm && hm && Number(hm[1]) > 0) return round3(Number(wm[1]) / Number(hm[1]));
    return null;
  }

  function lazyPdf() {
    if (window.pdfjsLib) return Promise.resolve(window.pdfjsLib);
    if (!window.vpLazy) return Promise.reject(new Error('PDF preview is unavailable.'));
    return Promise.resolve(window.vpLazy('pdfjs')).then(function () {
      if (!window.pdfjsLib) throw new Error('PDF preview is unavailable.');
      window.pdfjsLib.GlobalWorkerOptions.workerSrc = 'https://cdnjs.cloudflare.com/ajax/libs/pdf.js/3.11.174/pdf.worker.min.js';
      return window.pdfjsLib;
    });
  }

  // measure(file) -> Promise<{ kind, aspect, px, box, dpi, thumb, previewUrl? }>
  //   aspect: trimmed art width / height (3 decimals) or null when it can't be read
  //   thumb:  small PNG data URL (~240 px) for the row
  //   preview: full-size PNG data URL of a PDF's first page (the cart needs one beside the original PDF)
  function measure(file) {
    var ok = accepts(file);
    if (!ok.ok) return Promise.reject(new Error(ok.message));
    var kind = ok.kind;
    if (kind === 'pdf') {
      return file.arrayBuffer().then(function (buf) {
        return lazyPdf().then(function (pdfjs) { return pdfjs.getDocument({ data: new Uint8Array(buf) }).promise; });
      }).then(function (doc) {
        return doc.getPage(1).then(function (page) {
          var vp1 = page.getViewport({ scale: 1 });
          var scale = 2400 / Math.max(vp1.width, vp1.height);   // measure.py renders with sips -Z 2400
          var vp = page.getViewport({ scale: scale });
          var c = canvasFor(Math.round(vp.width), Math.round(vp.height));
          return page.render({ canvasContext: c.getContext('2d'), viewport: vp, background: 'rgba(0,0,0,0)' }).promise.then(function () {
            var m = measureRaster(c, c.width, c.height, true);
            var out = { kind: kind, aspect: m.aspect, px: m.px, box: m.box, dpi: null,
              pageIn: { w: round3(vp1.width / 72), h: round3(vp1.height / 72) },
              thumb: thumbFrom(c, c.width, c.height, 240), preview: c.toDataURL('image/png') };
            c.width = c.height = 0;
            try { doc.destroy(); } catch (e) {}
            return out;
          });
        });
      });
    }
    if (kind === 'file') {
      // AI (PDF-compatible), PSD, and whatever else the browser can draw: measured like a PNG. A file nothing can draw
      // gets its card and no shape: the customer types both sides.
      return window.VPArtFiles.render(file, 2400).then(function (r) {
        if (!r) {
          var card = window.VPArtFiles.card(file.name);
          var blank = { kind: kind, aspect: null, px: null, box: null, dpi: null, thumb: thumbFrom(card, 600, 600, 240), preview: card.toDataURL('image/png') };
          card.width = card.height = 0;
          return blank;
        }
        var c = r.canvas, m = measureRaster(c, c.width, c.height, r.alpha);
        var out = { kind: kind, aspect: m.aspect, px: r.px || m.px, box: m.box, dpi: null, thumb: thumbFrom(c, c.width, c.height, 240), preview: c.toDataURL('image/png') };
        if (r.pageIn) out.pageIn = { w: round3(r.pageIn.w), h: round3(r.pageIn.h) };
        if (r.dpi && r.scale) {
          out.dpi = r.dpi;
          out.inAtDpi = { w: round3(m.box[0] / r.scale / r.dpi[0]), h: round3(m.box[1] / r.scale / r.dpi[1]) };
        }
        c.width = c.height = 0;
        return out;
      });
    }
    if (kind === 'svg') {
      return file.text().then(function (text) {
        var aspect = svgAspect(text.slice(0, 20000));
        var url = URL.createObjectURL(file);
        return loadImage(url).then(function (img) {
          var w = img.naturalWidth || 240, h = img.naturalHeight || 240;
          var out = { kind: kind, aspect: aspect, px: [w, h], box: [w, h], dpi: null, thumb: thumbFrom(img, w, h, 240) };
          URL.revokeObjectURL(url);
          return out;
        }, function () { URL.revokeObjectURL(url); return { kind: kind, aspect: aspect, px: null, box: null, dpi: null, thumb: '' }; });
      });
    }
    return readHead(file, 65536).then(function (head) {
      var hasAlpha = kind === 'png' ? !!pngHasAlpha(head) : kind === 'webp' ? !!webpHasAlpha(head) : false;
      var dpi = kind === 'png' ? pngDpi(head) : null;
      var url = URL.createObjectURL(file);
      return loadImage(url).then(function (img) {
        var w = img.naturalWidth, h = img.naturalHeight;
        if (!w || !h) throw new Error('This image could not be opened.');
        var m = measureRaster(img, w, h, hasAlpha);
        var out = { kind: kind, aspect: m.aspect, px: m.px, box: m.box, dpi: null, thumb: thumbFrom(img, w, h, 240) };
        // measure.py: a real DPI is 30..9600 and not exactly 72
        if (dpi && dpi[0] >= 30 && dpi[0] <= 9600 && dpi[1] >= 30 && dpi[1] <= 9600 && !(Math.abs(dpi[0] - 72) < 0.01 && Math.abs(dpi[1] - 72) < 0.01)) {
          out.dpi = dpi;
          out.inAtDpi = { w: round3(m.box[0] / dpi[0]), h: round3(m.box[1] / dpi[1]) };
        }
        URL.revokeObjectURL(url);
        return out;
      }, function (e) { URL.revokeObjectURL(url); throw e; });
    });
  }

  // ── a row -> the builder's configuration and the quote spec ─────────────────
  // row = { id, fileName, file (File|null), material, laminate, cut, h, w, qty, whiteInk, whiteWhere, notes }
  // 10 for plain White Vinyl under Gloss or Matte; 20 for every other material or laminate.
  function minQty(row) {
    return row && row.material === 'white-vinyl' && (row.laminate === 'gloss' || row.laminate === 'matte') ? MIN_QTY : SPECIALTY_MIN_QTY;
  }

  // A laminate with a cuts list (Stardust: die only) is offered only on those cuts.
  function lamAllowed(lamId, cutId) {
    var lam = byId(LAMINATES, lamId);
    return !lam || !lam.cuts || lam.cuts.indexOf(cutId) !== -1;
  }

  function rowProblem(row) {
    if (row.missingFile) return 'Re-attach this file or remove the design. Saved artwork could not be opened.';
    if (!byId(MATERIALS, row.material)) return 'Pick a material.';
    if (!byId(LAMINATES, row.laminate)) return 'Pick a laminate.';
    if (!byId(CUTS, row.cut)) return 'Pick a cut.';
    if (!lamAllowed(row.laminate, row.cut)) return byId(LAMINATES, row.laminate).label + ' is die cut only.';
    if (!(Number(row.h) > 0) || !(Number(row.w) > 0)) return 'Enter a size.';
    var q = Number(row.qty);
    var min = minQty(row);
    if (!Number.isSafeInteger(q) || q < min) return min > MIN_QTY ? 'Minimum ' + min + ' for specialty finishes.' : 'Minimum ' + min + ' per design.';
    if (q > 1000000) return 'That quantity is too large.';
    var mat = byId(MATERIALS, row.material);
    if (mat.white && row.whiteInk === 'spot' && !String(row.whiteWhere || '').trim()) return 'Tell us where the white goes.';
    return null;
  }

  // pricing-engine.js vpQuoteFinish(): the base vinyl wins, then the laminate, then matte, then gloss.
  function quoteFinish(row) {
    var mat = byId(MATERIALS, row.material);
    if (mat && mat.id !== 'white-vinyl') return mat.id;
    var lam = byId(LAMINATES, row.laminate);
    return lam ? lam.quote : 'gloss';
  }

  // pricing-engine.js vpQuoteLaminate() (Josh 10/31 "Charge the laminate add"): a laminate on a non-white vinyl goes
  // beside it and the quote adds its flat price. Satin / gloss / matte add nothing.
  function quoteLaminate(row) {
    var mat = byId(MATERIALS, row.material);
    if (!mat || mat.id === 'white-vinyl') return '';
    var lam = byId(LAMINATES, row.laminate);
    return lam && lam.quote && lam.quote !== 'gloss' && lam.quote !== 'matte' ? lam.quote : '';
  }

  function quoteSpec(row) {
    var cut = byId(CUTS, row.cut);
    var spec = { w: round2(row.w), h: round2(row.h), qty: Number(row.qty), cut: cut ? cut.quote : 'tape', finish: quoteFinish(row), emboss: 'none' };
    var laminate = quoteLaminate(row);
    if (laminate) spec.laminate = laminate;
    return spec;
  }

  // ── prices ───────────────────────────────────────────────────────────────────
  var quoteCache = new Map();
  var inflight = 0, waiting = [];
  function slot() {
    if (inflight < 4) { inflight++; return Promise.resolve(); }
    return new Promise(function (resolve) { waiting.push(resolve); });
  }
  function release() { inflight--; var next = waiting.shift(); if (next) { inflight++; next(); } }

  // quote(row) -> Promise<{ ok, each, eachCents, totalCents, total, spec, message? }>
  // each is the builder's unit (rounded to the cent); total = cents(each) x qty, what Shopify charges.
  function quote(row) {
    var problem = rowProblem(row);
    if (problem && !/white goes/.test(problem)) return Promise.resolve({ ok: false, message: problem });
    var spec = quoteSpec(row);
    var key = [spec.w, spec.h, spec.qty, spec.cut, spec.finish, spec.emboss].join('|') + (spec.laminate ? '|' + spec.laminate : '');
    if (!quoteCache.has(key)) {
      var p = slot().then(function () {
        return fetch('/api/quote', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify(spec)
        });
      }).then(function (res) {
        if (!res.ok) throw new Error('quote http ' + res.status);
        return res.json();
      }).then(function (data) {
        var each = data && data.ok !== false ? Number(data.each) : NaN;
        if (!isFinite(each) || each <= 0) {
          return { ok: false, message: 'This size or quantity can’t be priced online. Contact the shop for a quote.' };
        }
        var ec = cents(each);
        return { ok: true, each: ec / 100, eachCents: ec, totalCents: ec * spec.qty, total: money(ec * spec.qty), spec: spec };
      }).catch(function () {
        quoteCache.delete(key);   // a network miss is not a price: try again next time
        return { ok: false, retry: true, message: 'Couldn’t reach pricing. Check your connection.' };
      }).finally(release);
      quoteCache.set(key, p);
    }
    return quoteCache.get(key);
  }

  // Rush (size-price skill, Josh 10/11): 15% of the products, $50 minimum. Its own line.
  function rushCents(productCents) {
    return Math.max(5000, Math.round(productCents * 0.15));
  }

  // The other items already in this browser's cart (from the builders, or designs this form added earlier), so the
  // form's total is the whole order. Only this form's own lines are left out: its rows replace them.
  function otherCartItems() {
    var items = [], mine = currentSession();
    try { items = JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || []; } catch (e) { items = []; }
    return items.filter(function (it) { return !(mine && it && it.configuration && it.configuration.bulkForm === mine); });
  }
  function otherCartCents() {
    return otherCartItems().reduce(function (sum, it) { return sum + cents(it.total || 0); }, 0);
  }

  // ── the hand-off to the shared cart ─────────────────────────────────────────
  function sizeText(row) { return inch(row.w) + '" \xd7 ' + inch(row.h) + '" (custom)'; }

  function notesFor(row) {
    var mat = byId(MATERIALS, row.material);
    var parts = [];
    // The Jotform's "File Name" column: the name the customer gives the design. It rides on the line when it isn't
    // just the file's own name (a renamed design, or one whose art comes later), so the shop sees their words.
    var name = String(row.fileName || '').trim();
    var stem = row.file ? String(row.file.name || '').replace(/\.[^.]+$/, '').trim() : '';
    if (name && name !== stem) parts.push('Design name: ' + name);
    if (mat && mat.white) {
      if (row.whiteInk === 'spot') parts.push('White ink: Spot — ' + String(row.whiteWhere || '').trim());
      else if (row.whiteInk === 'full') parts.push('White ink: Full');
      else parts.push('White ink: None');
    }
    var n = String(row.notes || '').trim();
    if (n) parts.push(n);
    return parts.join('\n').slice(0, 1000);   // Worker LIMITS.propValue
  }

  // The cart's order ref while the cart holds anything (the form's own earlier lines too), like the builder's
  // currentOrderRef: checking out the unchanged form again keeps the same names and resumes the saved checkout.
  function orderRef() {
    var ref = '', items = [];
    try { ref = sessionStorage.getItem('vp_order_ref') || ''; items = JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || []; } catch (e) {}
    if (/^ORD-\d{4}-[0-9a-f]{4}$/.test(ref) && items.length) return ref;
    if (typeof window.getNextOrderRef === 'function') return window.getNextOrderRef();
    var d = new Date();
    return 'ORD-' + String(d.getFullYear()).slice(-2) + String(d.getMonth() + 1).padStart(2, '0') + '-' +
      Math.floor(Math.random() * 0xFFFF).toString(16).padStart(4, '0');
  }

  function artworkFileName(ref, cut, mat, row, ext) {
    if (typeof window.buildArtworkFilename === 'function') {
      var d = new Date();
      var date = '' + d.getFullYear() + String(d.getMonth() + 1).padStart(2, '0') + String(d.getDate()).padStart(2, '0');
      // The same design gets the same name every time (a fixed tag from the row, not a random one), so checking out
      // the unchanged form again finds the saved checkout instead of making a second one.
      return window.buildArtworkFilename(ref, cut.productName, mat.label, sizeText(row), row.qty, ext, rowTag(row), date);
    }
    return ref + '_' + cut.productName.replace(/\W+/g, '') + '.' + ext;
  }

  function savedName(sessionId, row) {
    try {
      var items = JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || [];
      for (var i = 0; i < items.length; i++) {
        var c = items[i] && items[i].configuration;
        if (c && c.bulkForm === sessionId && c.bulkRow === String(row.id)) return String(items[i].artworkFile || '');
      }
    } catch (e) {}
    return '';
  }

  function rowTag(row) {
    var s = String(row.id) + '|' + String(row.fileName || '') + '|' + String(row.file ? row.file.name + ':' + row.file.size : '');
    var h = 2166136261;
    for (var i = 0; i < s.length; i++) { h ^= s.charCodeAt(i); h = Math.imul(h, 16777619) >>> 0; }
    return ('0000' + h.toString(36)).slice(-4);
  }

  // row + its price + its art -> { item, artwork } in the exact shape addToCart() saves.
  function cartItem(row, price, art, ref, sessionId) {
    var mat = byId(MATERIALS, row.material), lam = byId(LAMINATES, row.laminate), cut = byId(CUTS, row.cut);
    var spec = quoteSpec(row);
    var notes = notesFor(row);
    var hasArt = !!(art && (art.artworkUrl || art.artworkOriginalUrl));
    var isPdf = !!(art && art.artworkOriginalUrl);   // any original (PDF, AI, PSD…), not only a PDF
    // The extension comes from the file itself; row.fileName is the design name the customer can edit.
    var kind = row.file ? kindOf(row.file) : null;
    var ext = ({ pdf: 'pdf', png: 'png', jpeg: 'jpg', webp: 'webp', svg: 'svg' }[kind] || (row.file && window.VPArtFiles.ext(row.file.name)) || 'png');
    var file = hasArt ? artworkFileName(ref, cut, mat, row, ext) : '(none)';
    // The same design saved earlier (Back from Shopify, then Check out again, maybe after midnight) keeps its saved name:
    // only the date in it would differ, and a new name would start a second checkout (Sol 10/17 r3).
    var prev = savedName(sessionId, row);
    if (prev && prev.replace(/_\d{8}_/, '_') === file.replace(/_\d{8}_/, '_')) file = prev;
    var spot = lam.specialty;
    var specialtyLabel = spot === 'none' ? 'None' : lam.label;
    var laminateProp = spot !== 'none' ? lam.label : lam.finish === 'matte' ? 'Matte' : 'Gloss';
    var finishProp = FIN_LAB[spec.finish] || (lam.finish.charAt(0).toUpperCase() + lam.finish.slice(1));
    var unitFmt = price.each.toFixed(2);
    var properties = [
      { name: 'Product Type', value: cut.productName },
      { name: 'Material', value: mat.label },
      { name: 'Size', value: sizeText(row) },
      { name: 'Finish', value: finishProp },
      { name: 'Laminate', value: laminateProp },
      { name: 'Emboss', value: 'Flat' },
      { name: 'Specialty Finish', value: specialtyLabel },
      { name: 'Artwork File', value: file },
      { name: 'Preview Image', value: '[canvas PNG — see attached]' },
      { name: 'Unit Price', value: '$' + unitFmt },
      { name: 'Special Notes', value: notes || '—' }
    ];
    var configuration = {
      version: 1,
      cat: 'custom-stickers',
      chipId: cut.chipId,
      productName: cut.productName,
      nav: 'custom-stickers',
      sizeLabel: 'Custom',
      width: spec.w, height: spec.h,
      customW: inch(row.w), customH: inch(row.h),
      qty: spec.qty,
      materialId: mat.id,
      finish: lam.finish,
      specialty: spot,
      emboss: 'none',
      underlay: mat.id,
      packageSize: null,
      jarColor: null,
      uploadTab: 'body',
      // the customer's own file name, verbatim (the Worker names the Shopify file after it)
      bodyFilename: hasArt ? String(row.file && row.file.name || row.fileName || '').slice(0, 200) : '',
      lidFilename: '',
      notes: notes,
      artwork: { body: !!(art && art.artworkUrl), bodyOriginal: isPdf, lid: false, lidOriginal: false },
      bulkForm: sessionId,
      bulkRow: String(row.id)
    };
    return {
      item: {
        name: cut.productName,
        configuration: configuration,
        qty: spec.qty,
        unitPrice: unitFmt,
        total: money(price.totalCents),
        properties: properties,
        cat: 'custom-stickers',
        artworkFile: file,
        artworkThumb: art && art.cartThumb || '',
        thumbUrl: cut.thumb
      },
      artwork: hasArt ? {
        artworkUrl: art.artworkUrl || null,
        artworkOriginalUrl: art.artworkOriginalUrl || null,
        lidArtworkUrl: null, lidArtworkOriginalUrl: null
      } : null
    };
  }

  function jpegThumb(dataUrl) {
    if (!dataUrl) return Promise.resolve('');
    return loadImage(dataUrl).then(function (img) {
      var s = Math.min(1, 100 / img.naturalWidth, 100 / img.naturalHeight);
      var c = canvasFor(Math.max(1, Math.round(img.naturalWidth * s)), Math.max(1, Math.round(img.naturalHeight * s)));
      var ctx = c.getContext('2d');
      ctx.fillStyle = '#fff'; ctx.fillRect(0, 0, c.width, c.height);
      ctx.drawImage(img, 0, 0, c.width, c.height);
      return c.toDataURL('image/jpeg', 0.6);
    }).catch(function () { return ''; });
  }

  // The art a row's file becomes in the cart: the file itself (PNG/JPG/SVG/WebP), or for a PDF, AI, PSD or any other
  // file the original plus its rendered preview (restoreCartArtwork() needs both).
  function rowArtwork(row, measured) {
    if (!row.file) return Promise.resolve(null);
    var kind = kindOf(row.file);
    return readDataUrl(row.file).then(function (url) {
      // FileReader names the type from the browser's guess; the cart wants the real type.
      var fixed = url.replace(/^data:[^,]*,/, 'data:' + mimeOf(row.file, kind) + ';base64,');
      if (kind === 'pdf' || kind === 'file') {
        var preview = measured && measured.preview;
        var ready = preview ? Promise.resolve(preview) : measure(row.file).then(function (m) { return m.preview; });
        return ready.then(function (png) {
          return jpegThumb(png).then(function (thumb) { return { artworkUrl: png, artworkOriginalUrl: fixed, cartThumb: thumb }; });
        });
      }
      return jpegThumb(fixed).then(function (thumb) { return { artworkUrl: fixed, artworkOriginalUrl: null, cartThumb: thumb }; });
    });
  }

  // order = { name, email, rush, needBy, mockups, instagram, share, info, terms }
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  function orderProblem(order) {
    if (!order || !String(order.name || '').trim()) return 'Enter your name.';
    if (!EMAIL_RE.test(String(order.email || '').trim())) return 'Enter your email.';
    if (order.terms !== true) return 'Agree to the artwork terms to continue.';
    if (order.rush && !/^\d{4}-\d{2}-\d{2}$/.test(String(order.needBy || ''))) return 'Pick the date you need it by.';
    return null;
  }

  function cleanOrder(order) {
    var clip = function (s, n) { return String(s == null ? '' : s).trim().slice(0, n); };
    return {
      version: 1,
      form: FORM,
      name: clip(order.name, 100),
      email: clip(order.email, 254).toLowerCase(),
      rush: !!order.rush,
      needBy: order.rush ? clip(order.needBy, 10) : '',
      mockups: !!order.mockups,
      instagram: clip(order.instagram, 60).replace(/^@+/, ''),
      share: order.share === 'yes' ? 'yes' : order.share === 'no' ? 'no' : '',
      info: clip(order.info, 1000),
      terms: true
    };
  }

  // save(rows, order, measuredById?) -> Promise. Prices every row (refusing any it can't price), saves them to the
  // shared cart in one step (replacing this form's earlier rows) and saves the order extras.
  // measuredById: row.id -> measure() result (re-used for PDF previews).
  function save(rows, order, measuredById) {
    if (!rows || !rows.length) return Promise.reject(new Error('Add at least one design.'));
    if (rows.length > MAX_ROWS) return Promise.reject(new Error('One order can hold up to ' + MAX_ROWS + ' designs. Split it into two orders.'));
    for (var i = 0; i < rows.length; i++) {
      var p = rowProblem(rows[i]);
      if (p) return Promise.reject(new Error('Design ' + (i + 1) + ': ' + p));
    }
    var op = orderProblem(order);
    if (op) return Promise.reject(new Error(op));
    if (!window.VPProductCart || typeof window.VPProductCart.commitBuilderItems !== 'function') {
      return Promise.reject(new Error('The cart is unavailable. Refresh the page and try again.'));
    }
    var ref = orderRef();
    var sessionId = sessionKey();
    return Promise.all(rows.map(quote)).then(function (prices) {
      prices.forEach(function (pr, i) {
        if (!pr.ok) throw new Error('Design ' + (i + 1) + ': ' + pr.message);
      });
      // Art is read one file at a time: thirty full-size files at once is too much memory for a phone.
      var built = [];
      return rows.reduce(function (chain, row, i) {
        return chain.then(function () {
          return rowArtwork(row, measuredById && measuredById[row.id]).then(function (art) {
            built.push(cartItem(row, prices[i], art, ref, sessionId));
          });
        });
      }, Promise.resolve()).then(function () { return built; });
    }).then(function (built) {
      return window.VPProductCart.commitBuilderItems(built, sessionId, ref);
    }).then(function (saved) {
      sessionStorage.setItem(ORDER_KEY, JSON.stringify(cleanOrder(order)));
      return saved;
    });
  }

  // checkout(): save, then go to the cart, which starts the normal checkout on its own.
  function checkout(rows, order, measuredById) {
    return save(rows, order, measuredById).then(function () {
      (window.VPArtUpload && window.VPArtUpload.settleAll ? window.VPArtUpload.settleAll(120000) : Promise.resolve()).then(function () { location.href = "/?view=configurator&openCart=1&checkout=bulk"; });  // theme: vp-art.js
    });
  }

  // addToCart() (Josh 10/17: "i want them to be able to either add to cart or instant check out"): save and stay.
  // The lines belong to the cart from here on, so the form starts a new session: its next designs are added next to
  // them, never in their place. -> Promise<number of designs added>
  function addToCart(rows, order, measuredById) {
    return save(rows, order, measuredById).then(function (saved) {
      try { sessionStorage.removeItem('vp_bulk_session'); } catch (e) {}
      try {
        var cart = window.VPProductCart.read();
        var badge = document.getElementById('cartBadge');
        if (badge) { badge.textContent = cart.length; badge.style.display = cart.length ? 'inline-flex' : 'none'; }
        if (typeof window.renderCartDrawer === 'function') window.renderCartDrawer();
      } catch (e) { /* the cart is saved even if its display can't refresh */ }
      return saved.length;
    });
  }

  // Lines an earlier Add to cart (or Check out) left in the cart. A form with no designs of its own checks them out.
  function formCartLines() {
    var items = [];
    try { items = JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || []; } catch (e) { items = []; }
    return items.filter(function (it) { return !!(it && it.configuration && it.configuration.bulkForm); }).length;
  }
  function checkoutCart(order) {
    if (!formCartLines()) return Promise.reject(new Error('Add at least one design.'));
    var op = orderProblem(order);
    if (op) return Promise.reject(new Error(op));
    sessionStorage.setItem(ORDER_KEY, JSON.stringify(cleanOrder(order)));
    (window.VPArtUpload && window.VPArtUpload.settleAll ? window.VPArtUpload.settleAll(120000) : Promise.resolve()).then(function () { location.href = "/?view=configurator&openCart=1&checkout=bulk"; });  // theme: vp-art.js
    return Promise.resolve();
  }

  // Rows this session already committed to the cart, for Back and draft recovery.
  function cartRowIds() {
    var mine = currentSession();
    if (!mine) return [];
    try {
      return (JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || []).filter(function (it) {
        return it && it.configuration && it.configuration.bulkForm === mine;
      }).map(function (it) { return String(it.configuration.bulkRow); });
    } catch (e) { return []; }
  }

  // A form that opens with no designs no longer owns the lines its session left in the cart (its draft was cleared at
  // checkout): a new session keeps the next designs from replacing them.
  function releaseSession() {
    var mine = currentSession();
    if (!mine) return;
    try {
      var items = JSON.parse(sessionStorage.getItem('vp_cart') || '[]') || [];
      if (items.some(function (it) { return it && it.configuration && it.configuration.bulkForm === mine; })) sessionStorage.removeItem('vp_bulk_session');
    } catch (e) {}
  }

  function currentSession() {
    try { return sessionStorage.getItem('vp_bulk_session') || ''; } catch (e) { return ''; }
  }

  function sessionKey() {
    var k = '';
    try { k = sessionStorage.getItem('vp_bulk_session') || ''; } catch (e) {}
    if (!k) {
      var r = new Uint32Array(2);
      (window.crypto || {}).getRandomValues ? window.crypto.getRandomValues(r) : (r[0] = Date.now(), r[1] = Math.random() * 1e9);
      k = 'bulk-' + r[0].toString(36) + r[1].toString(36);
      try { sessionStorage.setItem('vp_bulk_session', k); } catch (e) {}
    }
    return k;
  }

  window.VPBulkCart = Object.freeze({
    MIN_QTY: MIN_QTY,
    minQty: minQty,
    MAX_ROWS: MAX_ROWS,
    MATERIALS: MATERIALS,
    LAMINATES: LAMINATES,
    CUTS: CUTS,
    lamAllowed: lamAllowed,
    WHITE_INK: WHITE_INK,
    accepts: accepts,
    measure: measure,
    fitSize: fitSize,
    rowProblem: rowProblem,
    quoteSpec: quoteSpec,
    quote: quote,
    rushCents: rushCents,
    otherCartItems: otherCartItems,
    otherCartCents: otherCartCents,
    orderProblem: orderProblem,
    cleanOrder: cleanOrder,
    toCartItem: cartItem,   // (row, price, art, orderRef, sessionId) -> { item, artwork }; checkout() uses it per row
    checkout: checkout,
    addToCart: addToCart,
    formCartLines: formCartLines,
    checkoutCart: checkoutCart,
    releaseSession: releaseSession,
    cartRowIds: cartRowIds,
    // for the page's 3D finish renders: VPQuote3D.set(render3d(row))
    render3d: function (row) {
      var mat = byId(MATERIALS, row.material) || MATERIALS[0];
      var lam = byId(LAMINATES, row.laminate) || LAMINATES[0];
      var cut = byId(CUTS, row.cut) || CUTS[0];
      return { finish: mat.finish3d, laminate: lam.lam3d, cut: cut.cut3d, emboss: 'none' };
    }
  });
}());
